import { ArrowUpRight } from "lucide-react"
import { useTranslation } from "react-i18next"
import "./AboutPreviewSection.css"

export function AboutPreviewSection() {
  const { t } = useTranslation()
  return (
    <section id="about" className="about-preview">
      <div className="container about-preview__grid">
        {/* Text column */}
        <div className="about-preview__text">
          <span className="about-preview__badge">{t("About Us")}</span>
          <h2 className="about-preview__title">
            {t("Your trusted road safety partner since 2018")}
          </h2>
          <p className="about-preview__desc">
            {t("Road's Reflectors Trading Est. supplies and installs a full range of road safety equipment — from Avery Dennison reflective sheeting and solar road studs to crash cushions and Scorpion truck-mounted attenuators.")}
          </p>
          <p className="about-preview__desc">
            {t("As exclusive agents in the Kingdom for leading global manufacturers, we've supplied projects for the Ministry of Transport, municipalities, the Ministry of Defense, the Ministry of Interior, and airports across Saudi Arabia.")}
          </p>

          <a href="/about" className="btn-pill btn-pill--brand about-preview__btn">
            {t("Read More About Us")}
            <span className="btn-pill__arrow">
              <ArrowUpRight size={14} />
            </span>
          </a>
        </div>

        {/* Image collage — one large photo on the left, two stacked on the right */}
        <div className="about-preview__media">
          <img
            src="/images/about/step-install-road-sign.jpeg"
            alt="Technician installing a reflective speed-limit sign"
            className="about-preview__img about-preview__img--main"
          />
          <img
            src="/images/about/step-inspect-reflective-sign.jpeg"
            alt="Technician inspecting a reflective road sign"
            className="about-preview__img about-preview__img--top"
          />
          <img
            src="/images/about/reflective-signs-riyadh.jpeg"
            alt="Reflective highway direction sign in Riyadh"
            className="about-preview__img about-preview__img--bottom"
          />
        </div>
      </div>
    </section>
  )
}